import React from 'react';
import PropTypes from 'prop-types';

import LastUpdated from '~components/common/LastUpdated';
import StatePageAccordion, {
  AccordionGroup,
} from '~components/common/Accordion/StatePageAccordion';

import { ContentSection } from '~components/Layout';
import { registrationNotRequired } from '~components/Register/specialCases';
import Markdown from '~components/common/Markdown';
import {
  amIRegistered,
  canIRegisterIfIHaveAFelonyConviction,
  canIRegisterInPerson,
  canIRegisterOnElectionDay,
  canIRegisterOnline,
  canIRegisterViaMail,
  doINeedToRegister,
  doINeedToUpdateRegistrationAfterMove,
  whatAreTheVoterRegistrationDeadlines,
  whenCanIPreregister,
  whoCanRegister,
} from '~utils/faqAnswersRegister';

function StateRegisterInfo({ state, info, showLastUpdated, styleTitleAsH1 }) {
  const stateHasVoterRegistration = !registrationNotRequired.includes(
    state.code
  );

  return (
    <ContentSection width='mid' isZebraStriped>
      {showLastUpdated && <LastUpdated array={state.state_information} />}

      <a id='registration' aria-hidden='true' />
      <h2 className={`mt-0 ${styleTitleAsH1 && 'text-4xl md:text-5xl'}`}>
        {`${state.name} voter registration guide`}
      </h2>

      <AccordionGroup>
        {stateHasVoterRegistration ? (
          <>
            <StatePageAccordion heading='What are the voter registration deadlines?'>
              <Markdown
                content={whatAreTheVoterRegistrationDeadlines(
                  info,
                  state.name,
                  state.code
                )}
              />
            </StatePageAccordion>
            <StatePageAccordion heading="How do I know if I'm registered to vote?">
              <Markdown content={amIRegistered(info, state.name, state.code)} />
            </StatePageAccordion>
            <StatePageAccordion
              heading={`Who can register to vote in ${state.name}?`}
            >
              <Markdown
                content={whoCanRegister(info, state.name, state.code)}
              />
            </StatePageAccordion>
            <StatePageAccordion
              heading={`Can I register to vote online in ${state.name}?`}
            >
              <Markdown
                content={canIRegisterOnline(info, state.name, state.code)}
              />
            </StatePageAccordion>
            <StatePageAccordion
              heading={`Can I register to vote via mail in ${state.name}?`}
            >
              <Markdown
                content={canIRegisterViaMail(info, state.name, state.code)}
              />
            </StatePageAccordion>
            <StatePageAccordion
              heading={`Can I register to vote in person in ${state.name}?`}
            >
              <Markdown
                content={canIRegisterInPerson(info, state.name, state.code)}
              />
            </StatePageAccordion>
            <StatePageAccordion heading='Can I register to vote on Election Day?'>
              <Markdown
                content={canIRegisterOnElectionDay(
                  info,
                  state.name,
                  state.code
                )}
              />
            </StatePageAccordion>
            <StatePageAccordion heading="I've moved. Do I have to update my registration?">
              <Markdown
                content={doINeedToUpdateRegistrationAfterMove(
                  info,
                  state.name,
                  state.code
                )}
              />
            </StatePageAccordion>
            <StatePageAccordion
              heading={`I'm not 18 yet. When can I submit my registration in ${state.name}?`}
            >
              <Markdown
                content={whenCanIPreregister(info, state.name, state.code)}
              />
            </StatePageAccordion>
            <StatePageAccordion
              heading={`I have a felony conviction. Can I register to vote in ${state.name}?`}
            >
              <Markdown content={canIRegisterIfIHaveAFelonyConviction(info)} />
            </StatePageAccordion>
          </>
        ) : (
          <StatePageAccordion
            heading={`Do I need to register to vote in ${state.name}?`}
          >
            <Markdown content={doINeedToRegister(state.name, state.code)} />
          </StatePageAccordion>
        )}
      </AccordionGroup>
    </ContentSection>
  );
}

StateRegisterInfo.propTypes = {
  state: PropTypes.object,
  info: PropTypes.object,
  showLastUpdated: PropTypes.bool,
  styleTitleAsH1: PropTypes.bool,
};

StateRegisterInfo.defaultProps = {
  styleTitleAsH1: true,
};

export default StateRegisterInfo;
